<template>
    <div class="group-setup" v-if="activityStatus !== 'APPROVED' && activityStatus !== 'REJECTED' &&
          role === 'CLUBS_PERFORMANCE_EVALUATION'
          ">
      <v-layout row v-if="errors">
        <v-flex>
          <Alert @dismissed="onDismissed" :text="errors"></Alert>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title dark>
          <h3 class="ma-2  orange--text">Activity Points Adjustment</h3>
        </v-card-title>
        <v-divider color="orange"></v-divider>
        <v-row class="pa-5">
          <v-col cols="6" md="6" sm="12">
            <v-text-field type="number" outlined dense v-model="form.point" label="Points*" required></v-text-field>
            <small>When you are entering minus points please use minus sign (-).</small>
          </v-col>
          <v-col cols="6" md="6" xs="12">
            <v-text-field v-model="form.comment" outlined dense label="Please enter point adjustment reason*">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3" xs="12">
            <v-btn large color="green" :disabled="!form.point || !form.comment" depressed block
              @click="submit()">Approved</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </template>
  
  <script>
  import { ActivityService } from "../../../../services/activity-service.js";
  import { checkError } from "@/config/errors.js";
  
  export default {
    name: "ActivityPointsAdjustment",
    props: [],
    components: {},
  
    data: () => ({
      errors: null,
      form: {
        point: null,
        comment: null,
        uuid: null,
        key:null
      },
      role: localStorage.getItem('role') || null,
      
    }),
  
    mounted() { 
      this.form.key = this.$route.params.key;
      this.form.uuid = this.$route.params.aId;
    },
  
    methods: {
  
      submit() {
        if (this.form.uuid !== null && this.form.key  !==null && this.form.point !== null && this.form.comment !== null) {
          this.errors = null,
        
            ActivityService.updateActivityPoints(this.form)
              .then((response) => {
                this.loading = false;
                if (response) {
                  location.reload();
                  this.form = [];
                }
              })
              .catch((error) => {
                this.loading = false;
                let data = error.response.data;
                let errorOutput = checkError.errorFormatting(data);
                this.errors = errorOutput;
              });
        } else {
          this.errors = 'Please enter all inputs';
        }
  
      }
  
    },
  };
  </script>
  